class RecipeDetailEmailFormController {

    constructor(recipeService, moveFocus, shopperService, $location, $timeout, $element) {
        this.recipeService = recipeService;
        this.moveFocus = moveFocus;
        this.shopperService = shopperService;
        this.$location = $location;
        this.$timeout = $timeout;
        this.$element = $element;

        this.formSubmitted = false;

        this.resetForm(true, true);
    }

    resetForm(resetMessage, initialLoad) {
        if (!initialLoad) {
            this.emailForm.$submitted = false;
        }

        if (resetMessage) {
            this.formSubmitted = false;
            this.emailSentMessage = undefined;
        }

        this.email = {
            recipientEmail: null,
            yourEmail: (this.shopperService.IsGuest)
                ? null
                : this.shopperService.Email,
            message: null,
            sendCopy: false,
        };
    }

    showSentMessage() {
        return this.emailSentMessage && this.formSubmitted;
    }

    focussedOnInput() {
        if (this.formSubmitted) {
            this.emailSentMessage = undefined;
            this.formSubmitted = false;
        }
    }

    submitForm() {
        if (!this.emailForm.$valid) {
            this.$timeout(() => {
                const dialog = this.$element.parents('#recipeEmailDialog');
                const topPosition = (Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - dialog.innerHeight()) / 2;
                dialog.css('top', topPosition);
            }, 0, false);
            return;
        }

        this.formSubmitted = true;
        this.recipeService.emailRecipe(this.$location.absUrl(), this.email.recipientEmail, this.email.yourEmail, this.email.message, this.email.sendCopy).then((response) => {
            this.emailSentMessage = response.MailStatusMessage;
            this.resetForm(false, false);
            this.moveFocus('._recipeEmailForm-confirmation');
        });
    }

    cancelDialog() {
        this.resetForm(true, false);
        this.moveFocus('.recipeExportOptions-email');
        this.$element.parents('#recipeEmailDialog').removeAttr('style');

    }

}

const recipeDetailFormComponentDefinition = {
    controller: ['RecipeService', 'MoveFocus', 'ShopperService', '$location', '$timeout', '$element', RecipeDetailEmailFormController],
    template: require('./recipe-detail-email-form.component.html').trim(),
};

module.exports = {
    RecipeDetailEmailFormController,
    recipeDetailFormComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipedetail/recipe-detail-email-form.component.js